import type { MakeName } from "@/types/make";

export function getAllMakeNames(): MakeName[] {
  return [
    "Ferrari",
    "Fiat",
    "Porsche",
    "Maserati",
    "Jaguar",
    "Lamborghini",
    "McLaren",
    "Alfa Romeo",
    "Aston Martin",
    "Bentley",
    "Mercedes-Benz",
    "Mini",
    "Ford",
    "Jeep",
    "Peugeot",
  ];
}
